import { render } from "./ProductValue.vue?vue&type=template&id=25eccb1b&scoped=true"
import script from "./ProductValue.vue?vue&type=script&lang=js"
export * from "./ProductValue.vue?vue&type=script&lang=js"

import "./ProductValue.vue?vue&type=style&index=0&id=25eccb1b&lang=scss"
import "./ProductValue.vue?vue&type=style&index=1&id=25eccb1b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25eccb1b"]])

export default __exports__